<template>
  <a-modal v-model="visible" width="880px" title="关联需求" @cancel="onClose" @ok="onClose">
    <a-row :gutter="16">
      <a-col :span="12">
        <a-card class="source-card" size="small" title="需求列表">
          <a-input-search @change="onChange" />
          <a-tree :loading="loading" checkable :tree-data="storyData" :checked-keys="targetKeys" @check="onCheck" />
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card class="target-card" size="small" :title="`已选择需求列表(${targetData.length})`">
          <a-tree :tree-data="targetData" />
        </a-card>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import { storySearch } from '@/api/project/story';
import { match } from 'pinyin-pro';
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    sourceData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    sourceKeys: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      visible: false,
      loading: true,
      filterValue: '',
      project_id: parseInt(this.$route.params.project_id) || null,
      sourceStoryData: [],
      storyData: [],
      targetData: [],
      targetKeys: []
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true) {
        this.targetData = this.sourceData;
        this.targetKeys = this.sourceKeys;
      }
    }
  },
  created() {
    this.getStoryList();
  },
  methods: {
    onClose() {
      this.$emit('close', this.targetData);
    },
    getStoryList() {
      this.loading = true;
      storySearch({ project_id: this.project_id })
        .then(res => {
          this.sourceStoryData = res.data.items.map(item => {
            return {
              key: item.id,
              title: `${item.id}. ${item.title}`,
              children: []
            };
          });
          this.storyData = [...this.sourceStoryData];
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onCheck(_, info) {
      const key = info.node.eventKey;
      const item = {
        key: key,
        title: info.node.title
      };
      if (info.checked === true) {
        this.targetKeys.push(key);
        this.targetData.push(item);
      } else {
        const keyIndex = this.targetKeys.indexOf(key);
        const dataIndex = this.targetData.indexOf(item);
        this.targetKeys.splice(keyIndex, 1);
        this.targetData.splice(dataIndex, 1);
      }
    },
    onChange(e) {
      const filterValue = e.target.value;
      if (filterValue !== '') {
        this.storyData = this.sourceStoryData.filter(item => match(item.title, filterValue));
      } else {
        this.storyData = [...this.sourceStoryData];
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.ant-tree li span.ant-tree-switcher {
  width: 0;
}
/deep/.ant-card-body {
  height: 360px;
  overflow: auto;
}
</style>
